import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ContentLoader, Tray } from '@frontend/design-system';
import { useScheduleReadOnlyRequestDetails } from '../../hooks';
import { ScheduleReadOnlyRequestDetails } from './ScheduleReadOnlyRequestDetails';

export const ScheduleReadOnlyRequestModal = () => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const scheduleRequestDetailProps = useScheduleReadOnlyRequestDetails();
  const { scheduleRequestModalProps, isLoading, handleCloseScheduleRequestModal } = scheduleRequestDetailProps;

  return (
    <ScheduleReadOnlyRequestDetails {...scheduleRequestDetailProps}>
      <Tray
        css={{ padding: 0, gap: 'unset' }}
        width='medium'
        {...scheduleRequestModalProps.modalProps}
        onClose={handleCloseScheduleRequestModal}
        autoFocusTimeout={3600000 * 2}
      >
        <ContentLoader show={isLoading} />
        <Tray.Header
          css={{
            alignItems: 'start',
            padding: theme.spacing(3, 3, 1, 3),
            borderBottom: `1px solid ${theme.colors.neutral10}`,
          }}
          Buttons={
            <Button
              variant='tertiary'
              label={t('Close Schedule Request Modal')}
              onClick={handleCloseScheduleRequestModal}
              iconName='x'
              size='large'
            />
          }
        >
          <ScheduleReadOnlyRequestDetails.Header />
        </Tray.Header>
        <Tray.Body css={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <ScheduleReadOnlyRequestDetails.Body />
          <ScheduleReadOnlyRequestDetails.Footer />
        </Tray.Body>
      </Tray>
    </ScheduleReadOnlyRequestDetails>
  );
};
